(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    root.querySelectorAll('[data-st-legacy-filter-toggle]').forEach(button => {
      if (button.dataset.stReady) return;
      button.dataset.stReady = 'true';
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = window.matchMedia('(max-width: 1023px)').matches;
      button.setAttribute('aria-expanded', String(!panel.hidden));
      button.addEventListener('click', () => {
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', String(!panel.hidden));
      });
    });
    root.querySelectorAll('.st-footer-column').forEach((details, index) => {
      if (!window.Shopify?.designMode && window.matchMedia('(max-width: 767px)').matches) details.open = index === 0;
    });
    root.querySelectorAll('[data-st-carousel]').forEach(shell => {
      if (shell.dataset.stReady) return;
      shell.dataset.stReady = 'true';
      const track = shell.querySelector('.st-track');
      if (!track) return;
      const progress = shell.querySelector('.st-progress span');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (progress) progress.style.transform = `scaleX(${max > 0 ? Math.max(.18, track.scrollLeft / max) : 1})`;
      };
      shell.querySelectorAll('[data-st-prev],[data-st-next]').forEach(button => button.addEventListener('click', () => {
        const direction = button.hasAttribute('data-st-prev') ? -1 : 1;
        const max = track.scrollWidth - track.clientWidth;
        const atEnd = direction > 0 && track.scrollLeft >= max - 2;
        const atStart = direction < 0 && track.scrollLeft <= 2;
        if (shell.classList.contains('st-social') && (atEnd || atStart)) track.scrollTo({left: atEnd ? 0 : max, behavior: reduced.matches ? 'instant' : 'smooth'});
        else track.scrollBy({left: direction * track.clientWidth * .8, behavior: reduced.matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('[data-st-toggle]').forEach(button => {
      if (button.dataset.stReady) return;
      button.dataset.stReady = 'true';
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        const open = panel.hidden;
        document.querySelectorAll('[data-st-toggle]').forEach(other => {
          const otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.hidden = true;
          other.setAttribute('aria-expanded', 'false');
        });
        panel.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
        if (open) panel.querySelector('input')?.focus();
      });
    });
    root.querySelectorAll('[data-st-announcements]').forEach(el => window.stInitAnnouncements?.(el));
    root.querySelectorAll('video[autoplay]').forEach(v => { if (reduced.matches) v.pause(); });
    root.querySelectorAll('[data-st-cookie-settings]').forEach(button => {
      if (button.dataset.stReady) return;
      button.dataset.stReady = 'true';
      const ready = () => typeof window.showPreferences === 'function' || !!document.querySelector('.isense-cc-settings');
      button.hidden = !ready();
      let attempts = 0;
      const waitForConsent = setInterval(() => { button.hidden = !ready(); if (!button.hidden || ++attempts >= 20 || !button.isConnected) clearInterval(waitForConsent); }, 500);
      button.addEventListener('click', () => {
        if (typeof window.showPreferences === 'function') window.showPreferences(button);
        else document.querySelector('.isense-cc-settings')?.click();
      });
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-st-toggle][aria-expanded="true"]').forEach(button => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
      button.setAttribute('aria-expanded','false');button.focus();
    });
  });
  document.addEventListener('cart:change', () => {
    document.querySelectorAll('.st-cart-count').forEach(el => el.classList.toggle('st-empty', Number(el.textContent) === 0));
  });
  document.addEventListener('shopify:section:load', event => init(event.target));

  // STOQ can replace the product form with a plain out-of-stock message.
  // Keep that unavailable state visible as a disabled button, without changing
  // any working purchase, preorder or restock-signup controls from the app.
  const restoreSoldOutButtons = () => {
    document.querySelectorAll('.product-info form.restock-rocket-preorder-button').forEach(form => {
      if (form.querySelector('button, input, select, textarea, a')) return;
      const message = form.textContent.trim();
      if (!/^(ikke på lager|uts(o|å)lgt|udsolgt|out of stock|sold out)$/i.test(message)) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.disabled = true;
      button.className = 'button st-sold-out-fallback';
      button.textContent = document.documentElement.lang.startsWith('da') ? 'Udsolgt' : message;
      form.replaceChildren(button);
    });
  };
  const productArea = document.querySelector('product-rerender');
  if (productArea) {
    new MutationObserver(restoreSoldOutButtons).observe(productArea, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    restoreSoldOutButtons();
  }
  init();
})();
